import { zodResolver } from "@hookform/resolvers/zod";
import { useSSOLogin } from "@theprelude/core";
import { Button, Form, InputFormField, notifyError } from "@theprelude/ds";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const FormSchema = z.object({
  slug: z.string(),
});

type SSOFormData = z.infer<typeof FormSchema>;

export function SSOView({
  slug,
  handle,
  onSignIn,
}: {
  slug?: string;
  handle?: string;
  onSignIn: () => void;
}) {
  const ssoLogin = useSSOLogin();

  useEffect(() => {
    if (slug && slug !== "") {
      ssoLogin.mutate(
        { slug },
        {
          onError: () => {
            notifyError({
              message: `We could not authorize SSO for ${slug}`,
            });
          },
        },
      );
    }
  }, [slug, handle, ssoLogin]);

  const form = useForm<SSOFormData>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      slug: slug,
    },
  });

  const onSubmit = (data: SSOFormData) => {
    ssoLogin.mutate(
      { slug: data.slug, handle },
      {
        onError: () => {
          notifyError({
            message: `We could not authorize SSO for ${data.slug}`,
          });
        },
      },
    );
  };

  const { register } = form;

  return (
    <div className="flex flex-col gap-4">
      <p className="text-base text-primary-foreground">
        Sign in by entering an email associated with your single sign-on (SSO)
        account below:
      </p>

      <Form className="flex flex-col gap-4" {...form} onSubmitValid={onSubmit}>
        <InputFormField
          label="Organization Slug"
          {...register("slug")}
          placeholder={"Required"}
          required
        />

        <Button
          intent="primary"
          type="submit"
          className="flex w-full justify-center"
          disabled={ssoLogin.isPending}
          loading={ssoLogin.isPending}
        >
          Sign in
        </Button>
      </Form>

      <p className="text-primary-foreground">
        Don&apos;t have a SSO account?{" "}
        <span
          onClick={onSignIn}
          role="button"
          className="cursor-pointer underline"
        >
          Sign in here
        </span>
      </p>
    </div>
  );
}
